import React from 'react';
import { Input, InputProps } from 'antd';
import { useField } from 'formik';

import FItem, { FItemProps } from './FItem';

type FItemInputProps = InputProps & {
  name: string;
  label?: string;
  formItemProps?: FItemProps;
  isPureFormItem?: boolean;
};

const FItemInput = ({
  name,
  label,
  formItemProps,
  isPureFormItem = false,
  ...props
}: FItemInputProps) => {
  const [field, meta] = useField(name);

  return (
    <FItem
      meta={meta}
      label={label}
      htmlFor={name}
      {...formItemProps}
      isPureFormItem={isPureFormItem}
    >
      <Input id={name} {...field} prefix={<span />} suffix={<span />} {...props} />
    </FItem>
  );
};

export default FItemInput;
